import { LoginCallback } from '@okta/okta-react';
import React, { useEffect } from 'react';
import { constants } from '../constants';
import { utility } from '../utility';

/**
 * OktaLoginCallback Component
 */
const OktaLoginCallback = () => {

  const isHistoryNavigate = performance.getEntriesByType("navigation")[0].type === constants.NavigationType.Forward;

  useEffect(() => {
    // History遷移の場合、TopPageに遷移
    if (isHistoryNavigate === true) {
      utility.transferTopPage();
    }
  }, []);
  
  if (isHistoryNavigate === true) {
    return <></>;
  }

  return (
    <LoginCallback />
  );
}
export default OktaLoginCallback;

